exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-79779609]{font-family:Open Sans,sans-serif;font-size:12px;line-height:1.3;color:#464646}.message_bottom[data-v-79779609]{margin-bottom:9px}.message_red[data-v-79779609]{color:#de1010}.message_bold[data-v-79779609]{font-size:14px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79779609","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/settings/components/message/Message.vue
// module id = 7874c4e95f1f93ec1ed4
// module chunks = 0